/* import __COLOCATED_TEMPLATE__ from './reference-circuit.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { getCapacitorPackage } from '../../utils/materials';

interface ReferenceCircuitArgs {
  circuitValues: { [key: string]: ReferenceCircuitComponentItem };
  r: string;
  c: string;
  showHelp?: (title: string, message: string, msgparams?: Record<string, unknown>) => void;
}

type ReferenceCircuitComponentItem = {
  name: string;
  value: string | number;
  url?: string;
  tolerance?: string | null;
};

export default class ReferenceCircuit extends Component<ReferenceCircuitArgs> {
  showReferenceStageHelp(): void {
    const title = 'help.next-steps.circuit.whats-this.title';
    const message = 'help.next-steps.circuit.whats-this.message';
    if (this.args.showHelp) {
      this.args.showHelp(title, message);
    }
  }
  @action referenceStageHelpClick(/*event*/): void {
    this.showReferenceStageHelp();
  }
  @action referenceStageHelpEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      this.showReferenceStageHelp();
    }
  }
  get c1Item(): ReferenceCircuitComponentItem {
    const item = Object.assign({}, this.args.circuitValues['c1']);
    const packageType = getCapacitorPackage(item.value, item.tolerance, true);
    if (packageType === '0603') {
      item.name = 'C1M';
    } else if (packageType === '1206') {
      item.name = 'C5M';
    }
    return item;
  }
  get c2Item(): ReferenceCircuitComponentItem {
    const item = Object.assign({}, this.args.circuitValues['c2']);
    const packageType = getCapacitorPackage(item.value, item.tolerance, true);
    if (packageType === '0603') {
      item.name = 'C2M';
    } else if (packageType === '1206') {
      item.name = 'C6M';
    }
    return item;
  }
  get c3Item(): ReferenceCircuitComponentItem {
    const item = Object.assign({}, this.args.circuitValues['c3']);
    const packageType = getCapacitorPackage(item.value, item.tolerance, true);
    if (packageType === '0603') {
      item.name = 'C3M';
    } else if (packageType === '1206') {
      item.name = 'C7M';
    }
    return item;
  }
}
